<template>
	<md-card class="md-layout-item md-size-100">
		<md-card-header class="md-card-header-text md-card-header-accent">
			<div v-if="customTitle" class="card-text">
				<h4 class="title">{{ customTitle }}</h4>
			</div>
			<div v-else class="card-text">
				<h4 v-if="!this.isNewEntity" class="title">Edição</h4>
				<h4 v-if="this.isNewEntity" class="title">Inclusão</h4>
			</div>
		</md-card-header>

		<md-card-content>
			<div v-if="!this.isNewEntity" class="md-layout md-layout-item md-size-100">
				<div style="margin-top: -40px; right: 10px; position: absolute" >
					<md-button v-for="(button, buttonIndex) in extendedButtons" :key="buttonIndex" class="md-accent" style="margin: 5px"
						@click="emmiter(button.func)">{{button.name}}</md-button>
					<md-button v-if="upload" class="md-accent" style="margin: 5px" @click="$emit('openUpload');">Upload</md-button>
					<md-button v-if="deleteEntity" @click="remove" class="md-danger">Excluir</md-button>
				</div>
			</div>

			<template v-for="(field, fieldIndex) in schema">
				<div class="md-layout" :key="fieldIndex" v-if="!field.hidden && !(field.creationHidden && isNewEntity) && (!field.creationOnly || isNewEntity) && !(field.name === 'id' && localEntity.id === 'novo')">
					<label class="md-layout-item md-size-20 md-form-label">
						{{ field.displayName }}
					</label>
					<div class="md-layout-item">
						<md-field v-if="field.kind === 'color-picker'">
							<md-input :name="field.name" v-model="localEntity[field.name]" type="text" :placeholder="field.placeholder" v-validate="field.validation" :disabled="field.readOnly || !updateEntity" :style="{ 'background-color': localEntity[field.name] }"></md-input>
						</md-field>
						<md-switch v-if="field.kind === 'switch'" v-model="switchValues[field.name]" @change="updateSwitches()"></md-switch>
						<md-field v-if="field.kind === 'text'">
							<md-input :name="field.name" v-model="localEntity[field.name]" type="text" v-validate="field.validation" :disabled="field.readOnly || !updateEntity" v-if="!field.mask"></md-input>
							<md-input :name="field.name" v-model="localEntity[field.name]" type="text" v-validate="field.validation" :disabled="field.readOnly || !updateEntity" v-mask="JSON.parse(JSON.stringify(field.mask))" v-if="field.mask"></md-input>
						</md-field>
						<md-field v-if="field.kind === 'date'">
							<md-input :name="field.name" v-model="localEntity[field.name]" type="date" v-validate="field.validation" :disabled="field.readOnly || !updateEntity"></md-input>
							<!-- 
							<md-input :name="field.name" v-model="localEntity[field.name]" type="text" v-validate="field.validation" :disabled="field.readOnly || !updateEntity" v-mask="JSON.parse(JSON.stringify(field.mask))" v-if="field.mask"></md-input>
							-->
						</md-field>
						<md-field v-if="field.kind === 'long-text'">
							<md-textarea md-autogrow :name="field.name" v-model="localEntity[field.name]" type="text" v-validate="field.validation" :disabled="field.readOnly || !updateEntity" style="min-height: 100px;"></md-textarea>
						</md-field>
						<!-- editor HTML -->
						<md-field v-if="field.kind === 'html'">
							<editor apiKey="jsyigy0isp2ob9v4kmzcj8u5qyoeon50s8vuj2zip2pu5w5l" :init="field.editorConfig" v-model="localEntity[field.name]" :id="field.editorId"></editor>
						</md-field>
						
						<div class="link-field" v-if="field.kind === 'file-url'">
							<a v-if="localEntity[field.name] && localEntity[field.name] !== ''" target="_blank" :href="localEntity[field.name]">Abrir arquivo</a>
							<span v-else-if="isNewEntity">Envie no próximo passo</span>
							<span v-else>Arquivo não enviado</span>
						</div>
						<div class="link-field" v-if="field.kind === 'video-url'">
							<a v-if="localEntity[field.name] && localEntity[field.name] !== ''" target="_blank" :href="localEntity[field.name].videoUrl">Abrir arquivo</a>
							<span v-else-if="isNewEntity">Envie no próximo passo</span>
							<span v-else>Arquivo não enviado</span>
						</div>
						<div class="link-field" v-if="field.kind === 'picture-url'">
							<a v-if="localEntity[field.name] && localEntity[field.name] !== ''" target="_blank" :href="localEntity[field.name]">
								<img class="image-preview" :src="localEntity[field.name]">
							</a>
							<span v-else-if="isNewEntity">Envie no próximo passo</span>
							<span v-else>Imagem não enviada</span>
						</div>
						<md-field v-if="field.kind === 'password'">
							<md-input :name="field.name" v-model="localEntity[field.name]" type="password" v-validate="field.validation" :disabled="field.readOnly || !updateEntity"></md-input>
						</md-field>
						<md-field v-if="field.kind === 'select'">
							<md-select :name="field.name" v-model="localEntity[field.name]" v-validate="field.validation">
								<md-option v-for="(option, optionIndex) in field.options" :key="optionIndex" :value="option.value" :label="option.name"  :disabled="field.readOnly || !updateEntity">{{ option.name }}</md-option>
							</md-select>
						</md-field>
						<form v-if="field.upload && !isNewEntity" enctype="multipart/form-data" novalidate>
							<div class="dropbox">
								<input type="file" :accept="field.accept" :name="field.name" :disabled="fieldsUploading[field.name]" class="input-file" @change="uploadFile($event.target.files, field)">
								<span>
									<p v-if="!fieldsUploading[field.name]">{{ localEntity[field.name] && localEntity[field.name] !== '' ?  "Arraste um novo arquivo para atualizar" : "Clique ou arraste um arquivo para enviar" }}</p>
									<p v-if="fieldsUploading[field.name]">Carregando...</p>
								</span>
							</div>
						</form>
					</div>
					<label class="md-layout-item md-size-20 md-label-on-right">
						<code v-if="errors.has(field.name)">Obrigatório</code>
					</label>
				</div>
			</template>


		</md-card-content>

		<!-- style="display: flex; justify-content: space-between; align-items: right;" -->
		<md-card-actions v-if="updateEntity" class="text-center">
			<md-button native-type="submit" @click.native.prevent="validateAndSubmit" class="md-accent">Enviar</md-button>
			<md-button v-if="syncEntity" class="md-accent" style="margin-left: 120px;"
                    @click="syncEntity">Atualizar Sub-Empresas</md-button>                  			
		</md-card-actions>
	</md-card>
</template>

<script>
	import EspressoAux from "./EspressoAux.vue";
	import Editor from '@tinymce/tinymce-vue';

	export default {
		name: "EntityCard",
		props: {
			schema: Array,
			entity: Object,
			createEntity: Function,
			readEntity: Function,
			updateEntity: Function,
			deleteEntity: Function,
			customTitle: String,
			upload: Boolean,
			notConfirm: Boolean,
			extendedButtons: Array,
			submitErrorHandler: Function,
			syncEntity: Function
		},
		components: {
			Editor
		},
		data() {
			return {
				color: "#000000",
				localEntity: this.entity,
				switchValues: {},
				fieldsUploading: {},
			};
		},
		computed: {
			isNewEntity() {
				return !this.localEntity.id || this.localEntity.id === "novo";
			},
		},
		methods: {
			validateAndSubmit() {
				EspressoAux.executeAsync(async () => {
					if (!await this.$validator.validateAll()) {
						throw Error("MISSING_FIELDS");
					}

					if (!this.notConfirm) {
						if (!(await EspressoAux.showConfirmationModal()).value) {
							throw Error("CANCELLED");
						}
					}

					if (this.isNewEntity) { // create new entity
						if (!this.createEntity) {
							throw Error("NOT_ALLOWED");
						}
						delete this.localEntity.id;
						this.localEntity = await this.createEntity(this.localEntity);
					} else { // update existing entity
						if (!this.updateEntity) {
							throw Error("NOT_ALLOWED");
						}
						const dataToUpdate = {
							id: this.localEntity.id,
						};
						// delete read only fields from update
						this.schema.forEach(field => {
							if (!field.readOnly && !field.hidden && typeof this.localEntity[field.name] !== "undefined") {
								dataToUpdate[field.name] = this.localEntity[field.name];
								console.log(field.name, ' : ', field.kind, ' = ', this.localEntity[field.name]);
								if (field.kind === "date") {
									if (this.localEntity[field.name]) {
										dataToUpdate[field.name] = new Date(`${this.localEntity[field.name]}T00:00:00`);
									} else {
										dataToUpdate[field.name] = null;
									}
								}
							}
						});
						this.localEntity = await this.updateEntity(dataToUpdate);
						await this.loadEntity(false);
					}
				}, "Informações enviadas!", "Erro de envio de informações", this.submitErrorHandler);
			},
			remove() {
				EspressoAux.executeAsync(async() => {
					if (!this.deleteEntity) {
						throw Error("NOT_ALLOWED");
					}
					if (!(await EspressoAux.showConfirmationModal()).value) {
						throw Error("CANCELLED");
					}
					await this.deleteEntity(this.localEntity.id);
				}, "Entrada excluída!", "Erro ao excluir entrada");
			},
			updateSwitches() {
				Object.entries(this.switchValues).forEach(([fieldName, status]) => {
					const schemaField = this.schema.find(field => field.name === fieldName);
					if (status) {
						this.localEntity[fieldName] = schemaField.valueOn;
					} else {
						this.localEntity[fieldName] = schemaField.valueOff;
					}
				});
			},
			loadEntity(loadFromAPI = true) {
				if (!this.isNewEntity) {
					EspressoAux.executeAsync(async () => {
						if (loadFromAPI) {
							this.localEntity = await this.readEntity(this.localEntity.id);
						}

						Object.entries(this.localEntity).forEach(([entityKey, entityValue]) => {
							const schemaField = this.schema.find(field => field.name === entityKey);

							// format read only properties
							if (schemaField && schemaField.readOnly && schemaField.formatter) {
								this.localEntity[entityKey] = schemaField.formatter(entityValue);
							}
							// populate switchValues
							if (schemaField && schemaField.kind === "switch") {
								this.$set(this.switchValues, schemaField.name, this.localEntity[schemaField.name] === schemaField.valueOn ? true : null);
							}
							//
							if (schemaField && schemaField.kind === "date" && entityValue) {
								this.localEntity[entityKey] = entityValue.split('T')[0];
							}

							// populate uploadStatuses
							if (schemaField && schemaField.upload) {
								this.$set(this.fieldsUploading, schemaField.name, false);
							}
						});
					}, null, null, () => {
						this.$router.go(-1);
						EspressoAux.showFailModal("Erro ao carregar informações!");
					});
				}
			},
			uploadFile(fileList, field) {
				EspressoAux.executeAsync(async () => {
					this.fieldsUploading[field.name] = true;
					await Promise.all(Array.from(fileList).map((file) => field.upload(this.localEntity.id, file)));
					this.fieldsUploading[field.name] = false;
					await this.loadEntity();
					return EspressoAux.showSuccessModal();
				}, null, null, async (error) => {
					this.fieldsUploading[field.name] = false;
					if (error.error === "UPLOAD_REQUEST_TOO_LARGE") {
						return EspressoAux.showFailModal(`Tamanho do arquivo excede o limite de ${error.details.maxSize} MB.`);
					} else if (error.error === "UPLOAD_FILETYPE") {
						return EspressoAux.showFailModal(`Formato de arquivo não suportado. Formatos permitidos: (${error.details.fileTypes})`);
					}
					return EspressoAux.showFailModal("Não foi possível importar!");
				});
			},
			emmiter(func) {
				this.$emit(func);
			}
		},
		watch: {
			localEntity() {
				this.$emit('update:entity', this.localEntity);
			},
			entity(newEntity) {
				if (newEntity.id !== this.localEntity.id) {
					this.localEntity = newEntity;
					this.loadEntity();
				}
			},
		},
		mounted() {
			this.loadEntity();
		},
	};
</script>

<style lang="scss" scoped>
	.md-card .md-card-actions{
		border: none;
	}
	.text-center {
		justify-content: center !important;
	}
	.link-field {
		padding-bottom: 10px;
		padding-top: 5px;
		margin: 13px 0 0;
		min-height: auto;
	}
	.image-preview {
		max-height: 50px;
		width: auto;
		background-color: #eee;
	}
	.dropbox {
		outline: 2px dashed grey; /* the dash box */
		outline-offset: -10px;
		background: whitesmoke;
		color: dimgray;
		padding: 10px 20px;
		height: 100px;
		position: relative;
		cursor: pointer;
		line-height: 90px;
		text-align: center;
	}

	.input-file {
		opacity: 0; /* invisible but it's there! */
		width: 100%;
		height: 100px;
		position: absolute;
		cursor: pointer;
	}

	.dropbox:hover {
		background: rgba(198, 240, 198, 0.502); /* when mouse over to the drop zone, change color */
	}

	.dropbox p {
		font-size: 1.2em;
		text-align: center;
		margin-top: 0;
	}

	.dropbox span {
		display: inline-block;
		vertical-align: middle;
		line-height: normal;
	}
</style>
